
/// <amd-module name="Build/Common/Library/Legacy/Components/ShelvesetAction" />
import { Action } from "Build/Flux/Action";

export interface IShelvesetPickerActionCreatorOptions {
    actionHub?: ShelvesetPickerActionHub;
}

export class ShelvesetPickerActionCreator {
    private _actionHub: ShelvesetPickerActionHub;

    constructor(options: IShelvesetPickerActionCreatorOptions) {
        this._actionHub = options.actionHub || new ShelvesetPickerActionHub();
    }

    public closePicker(payload: string) {
        this._actionHub.pickerDismissed.invoke(payload); 
    }
}

export class ShelvesetPickerActionHub {
    private _pickerDismissed: Action<string>;

    constructor() {
        this._pickerDismissed = new Action<string>();
    }

    public get pickerDismissed(): Action<string> {
        return this._pickerDismissed;
    }
}


